import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, checked } = useAuth();
  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg0">
        <div className="overline animate-pulse">Loading your closet…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};
